import React, { useEffect, useState } from 'react'
import { getStudentSanctionContentBySanctionType } from '../../services/reservoir'
import parse from 'html-react-parser';
import { getEnrolSanctionsType } from '../../helpers/enrolment'

function SanctionCard ({ sanctions, courseId }) {

    const [ sanctionContents, setSanctionContents ] = useState([]);
    const [ loadingError, setLoadingError ] = useState(false);

    useEffect(() => {
        const sanctionTypes = getEnrolSanctionsType(sanctions, courseId) || []

        Promise.all(sanctionTypes.map(type => getStudentSanctionContentBySanctionType(type)))
            .then(contents => {
                const sanctionNodes = contents.flat().reduce((acc, curr) => {
                    if (!acc.some(item => item.id === curr.id)) {
                        acc.push(curr)
                    }
                    return acc
                }, [])

                const sanctionContents = sanctionNodes.map(item => {
                    return item.attributes.body.value
                })

                setSanctionContents(sanctionContents)
            })
            .catch(error => {
                setLoadingError(true)
            })
    }, [sanctions, courseId])

    return loadingError ? (
        <div className="sidenote sidenote--error">
            <div className="sidenote__content">
                <h3 style={{ paddingTop: 0 }}>Trying to Enrol?</h3>
                <p>
                    We encourage you to complete your enrolment as early as possible, however, if you need help or cannot enrol, our teams are happy to assist. You can contact your Course and Unit
                    Advisor by submitting an enquiry online or attending a drop-in session to discuss in person.
                </p>
                <p>
                    For further information, please refer to our{' '}
                    <a href="https://www.vu.edu.au/course-unit-advice" target="_blank">
                        Course &amp; Unit Advisors
                    </a>{' '}
                    page.
                </p>
            </div>
        </div>
    ) : (
        <div>
            {
                sanctionContents.length > 0 ? 
                sanctionContents.map((content, index) => (
                    <div key={index} className="sidenote sidenote--error">
                        <div className="sidenote__content">
                            <div>{parse(content)}</div>
                        </div>
                    </div>
                ))
                : null
            }
        </div>
    )
}

export default SanctionCard